/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Export_Options_AriaInputs */

const en_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Tech Export Options`)
};

const fr_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'export Drastic Tech`)
};

const de_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastische Technologieexportoptionen`)
};

const it_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di esportazione tecnologica drastiche`)
};

const ru_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Варианты экспорта радикальных технологий`)
};

const es_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones drásticas para la exportación de tecnología`)
};

const zh_cn2_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激进的技术出口选项`)
};

const ja_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抜本的な技術輸出オプション`)
};

const hi_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तकनीकी निर्यात के लिए व्यापक विकल्प`)
};

const pt_pt2_drastic_tech_export_options_aria = /** @type {(inputs: Drastic_Tech_Export_Options_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções drásticas de exportação de tecnologia`)
};

/**
* | output |
* | --- |
* | "Drastic Tech Export Options" |
*
* @param {Drastic_Tech_Export_Options_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_export_options_aria = /** @type {((inputs?: Drastic_Tech_Export_Options_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Export_Options_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_export_options_aria(inputs)
	if (locale === "de") return de_drastic_tech_export_options_aria(inputs)
	if (locale === "it") return it_drastic_tech_export_options_aria(inputs)
	if (locale === "ru") return ru_drastic_tech_export_options_aria(inputs)
	if (locale === "es") return es_drastic_tech_export_options_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_export_options_aria(inputs)
	if (locale === "ja") return ja_drastic_tech_export_options_aria(inputs)
	if (locale === "hi") return hi_drastic_tech_export_options_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_export_options_aria(inputs)
	return en_drastic_tech_export_options_aria(inputs)
});